import * as React from 'react';
import { warning } from '../../definitions/colors';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgUserWarn = props => _jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...props,
  children: [_jsx("path", {
    d: "M6.1 10.1H2.6c-.3 0-.5-.2-.6-.5v-.3c.2-.3.3-.6.5-.9 1-1.9 2-3.7 3-5.6 0-.2.2-.3.5-.3.2 0 .4 0 .5.2.2.3.3.5.5.8 1 1.9 2 3.7 3.1 5.6.2.4 0 .7-.3.9H6.1ZM6.7 6V5c0-.1 0-.2-.2-.2H5.4v2.1c0 .1 0 .2.2.2h.8c.1 0 .2 0 .2-.2v-1Zm0 2.4V8c0-.1 0-.2-.2-.2h-.8c-.1 0-.2 0-.2.2v.8c0 .1 0 .2.2.2h.8c.1 0 .2 0 .2-.2v-.4Z",
    style: {
      fill: warning[400]
    }
  }), _jsx("path", {
    d: "M14.2 5.9c-1.6 0-3.1.5-4.4 1.3.3.5.6 1.1.9 1.6.2.4.2.8 0 1.1-.1.4-.4.6-.8.8H6.8c-.3.9-.5 1.8-.5 2.8 0 4.3 3.4 7.8 7.8 7.8s7.7-3.5 7.8-7.8c0-4.3-3.4-7.8-7.8-7.8Zm0 2.2c1.8 0 3.4 1.5 3.4 3.3 0 1.8-1.5 3.4-3.3 3.4-1.8 0-3.4-1.5-3.4-3.3 0-1.8 1.5-3.4 3.3-3.4Zm5.4 9.5c-.4.6-.9 1.1-1.5 1.5-.7.5-1.5.9-2.3 1.1-.5.1-1.1.2-1.7.2-1.6 0-3-.5-4.2-1.6-.4-.4-.8-.8-1.1-1.2v-.1c.1-.7.3-1.5.7-2.1.4-.6.9-1 1.6-1.1h.2c.5.5 1 .8 1.6 1 .7.3 1.4.3 2.1.2.9-.2 1.6-.6 2.3-1.2h.2c.6.1 1.1.5 1.5 1 .4.7.6 1.4.7 2.2v.1Z"
  })]
});
export default SvgUserWarn;